import { Component } from '@angular/core';
import { getStatusMark } from 'src/app/const/entity-view-constants';
import { SharedResultComponent } from '../result-shared.component';

@Component({
  selector: 'app-community-project-result',
  templateUrl: './community-project-result.component.html',
  styleUrls: ['../map-result-item.component.scss'],
})
export class CommunityProjectResultComponent extends SharedResultComponent {
  public get getStatusMark(): string {
    return getStatusMark(this.data.status);
  }
}
